import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TrackingReportDetailsRequestDto,
  TrackingReportExportRequestDto,
  TrackingReportMetricsRequestDto,
} from "../../../../dto/AdminPanel/AdminPanelTrackingReportDto";
import {
  TrackingReportDealModel,
  TrackingReportDetailsModel,
  TrackingReportMetricsModel,
} from "../../../../viewModels/AdminPanel/TrackingReportModel";

export type TrackingReportState = {
  metrics?: TrackingReportMetricsModel;
  details?: TrackingReportDetailsModel;
  exportRows?: TrackingReportDealModel[];
  metricsLoading: boolean;
  detailsLoading: boolean;
  exportLoading: boolean;
  metricsError: boolean;
  detailsError: boolean;
  exportError: boolean;
};

const initialState: TrackingReportState = {
  metricsLoading: false,
  detailsLoading: false,
  exportLoading: false,
  metricsError: false,
  detailsError: false,
  exportError: false,
};

export const createTrackingReportSlice = <Name extends string>(name: Name) =>
  createSlice({
    name,
    initialState,
    reducers: {
      loadMetrics(state, _action: PayloadAction<TrackingReportMetricsRequestDto>) {
        state.metricsLoading = true;
        state.metricsError = false;
      },
      loadMetricsSuccess(state, action: PayloadAction<TrackingReportMetricsModel>) {
        state.metrics = action.payload;
        state.metricsLoading = false;
      },
      loadMetricsReject(state) {
        state.metricsLoading = false;
        state.metricsError = true;
      },
      loadDetails(state, _action: PayloadAction<TrackingReportDetailsRequestDto>) {
        state.detailsLoading = true;
        state.detailsError = false;
      },
      loadDetailsSuccess(state, action: PayloadAction<TrackingReportDetailsModel>) {
        state.details = action.payload;
        state.detailsLoading = false;
      },
      loadDetailsReject(state) {
        state.detailsLoading = false;
        state.detailsError = true;
      },
      loadExport(state, _action: PayloadAction<TrackingReportExportRequestDto>) {
        state.exportRows = undefined;
        state.exportLoading = true;
        state.exportError = false;
      },
      loadExportSuccess(state, action: PayloadAction<TrackingReportDealModel[]>) {
        state.exportRows = action.payload;
        state.exportLoading = false;
      },
      loadExportReject(state) {
        state.exportLoading = false;
        state.exportError = true;
      },
      clearExport(state) {
        state.exportRows = undefined;
      },
      reset() {
        return initialState;
      },
    },
  });
